import { render, staticRenderFns } from "./OrderInterception.vue?vue&type=template&id=6481ca7c&"
import script from "./OrderInterception.vue?vue&type=script&lang=js&"
export * from "./OrderInterception.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports